import { AxiosResponse } from "axios";

export enum ExportFormat {
  PDF = "PDF",
  DOCX = "DOCX",
  XLSX = "XLSX",
}

export interface FileDownload {
  blob: Blob;
  fileName: string;
}

const parseContentDispositionFileName = (disposition: string): string | null => {
  const encoded = /filename\*=(?:UTF-8'')?["']?([^"';]+)/i.exec(disposition);
  if (encoded?.[1]) return decodeURIComponent(encoded[1]);
  const plain = /filename=["']?([^"';]+)["']?/i.exec(disposition);
  return plain?.[1]?.trim() ?? null;
};

export const extractFileDownload = (
  response: AxiosResponse<Blob>,
  fallbackFileName: string
): FileDownload => ({
  blob: response.data,
  fileName:
    parseContentDispositionFileName(
      response.headers["content-disposition"] ?? ""
    ) ?? fallbackFileName,
});
